import { z } from 'zod';
/**
 * Must match `emailAndPassword.minPasswordLength` in apps/api/src/auth/index.ts.
 * If the two drift apart the form happily accepts a password that better-auth
 * then refuses, and the error surfaces with no field to attach it to.
 */
export const MIN_PASSWORD_LENGTH = 10;
/**
 * Changing the sign-in address. The current password is not ceremony: it is
 * the only proof of control we have until Resend is wired up in Phase 1b and
 * the new address can be sent a verification link.
 */
export const changeEmailSchema = z.object({
    // Normalise before validating, not after: z.email() rejects the padding
    // that a paste from a contacts app brings with it, and the trim would
    // otherwise run too late to save it.
    email: z.string().trim().toLowerCase().pipe(z.email().max(255)),
    currentPassword: z.string().min(1),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    newPassword: z.string().min(MIN_PASSWORD_LENGTH).max(200),
});
